import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import Community from "./Community";
import { useDispatch } from "react-redux";

import * as APIS from "../../utils/service";
import { close, open } from "../../redux/popupSlice";
import { getMemberinfo } from "../../utils/utils";
import consts from "../../libs/consts"
import ReportPop from "./ReportPop";

const levelText = ['', '중개보조원', '공인중개사', '대표공인중개사'];

const GatheringContent = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [params, setSearchParams] = useSearchParams();
    const gathering = params.get("group");

    const [groupInfo, setGroupInfo] = useState(null);
    const [detailInfo, setDetailInfo] = useState(null); // 게시글 상세정보
    const [orgComments, setOrgComments] = useState([]); // 댓글 리스트 (오리진)
    const [commentList, setCommentList] = useState([]); // 댓글 리스트 (데이터 변환)
    const [memberinfos, setmemberinfos] = useState({}); // 로그인된 사용자 정보

    const [comment, setComment] = useState(""); // 댓글내용
    const [recommnetIdx, setRecommnetIdx] = useState("") // 대댓글 상위 아이디
    const [recommnetDesc, setRecommnetDesc] = useState("") // 대댓들 내용

    const [menuCmtIdx, setMenuCmtIdx] = useState("") // 댓글 옵션창 오픈 
    const [editCmtIdx, setEditCmtIdx] = useState("") // 댓글 수정 Idx
    const [editCmtText, setEditCmtText] = useState("") // 댓글 수정 텍스트

    const [noticeList, setNoticeList] = useState([]); //공지 리스트

    const [reportFlag, setreportFlag] = useState(false); //신고 팝업
    const [reportData, setreportData] = useState(null);

    //메시지 팝업
    const messagePopup = (msg, title = '알림') => {
        dispatch(
            open({
                component: msg,
                title: title,
                button: "확인",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                },
            })
        );
    }

    //대댓글 파싱
    const groupComment = (cmts = []) => {
        let renewList = [];
        // 댓글들만 필터링
        renewList = cmts.filter(v => !v?.parent_idx)

        // 대댓글을 상위 댓글 밑으로 추가
        for (let reCmt of cmts.filter(v => v?.parent_idx)) {
            let findIndex = renewList.findIndex(v => v?.idx == reCmt?.parent_idx);

            if (findIndex >= 0) {
                if (!("childs" in renewList[findIndex])) {
                    renewList[findIndex].childs = [];
                }
                renewList[findIndex].childs.push(reCmt)
            }
        }
        setCommentList(renewList)
    }

    const loadDetail = (reload = false) => {
        if (params.get("idx")) {
            let sender = {
                idx: params.get("idx"),
                reload
            };

            APIS.postData('/v1/communityGroup/getBoad', sender).then(({ data }) => {
                if (data) {
                    setDetailInfo(data)
                    if (data?.comments?.length > 0) {
                        setOrgComments(data?.comments)
                        groupComment(data?.comments)
                    }
                }
            }).catch(({ response }) => {
                const { data } = response;
                messagePopup('해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.')
            }).finally(() => {
            });
        } else {
            messagePopup('해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.')
        }
    }

    // 코맨트
    const commentFunc = (parent_idx, tag_name) => {
        let sender = {
            target_idx: detailInfo?.idx,
            desc: parent_idx ? recommnetDesc : comment,
            parent_idx,
            tag_name,
        }

        if (!parent_idx && !comment) {
            return;
        }

        if (parent_idx && !recommnetDesc) {
            return;
        }

        if (!detailInfo) {
            return;
        }

        APIS.postData('/v1/communityGroup/comment', sender).then(({ data }) => {
            loadDetail(true);
            if (parent_idx) {
                setRecommnetDesc("")
                setRecommnetIdx("")
            } else {
                setComment("")
            }
            messagePopup('댓글이 작성되었습니다.')

        }).catch(({ response }) => {
            const { data } = response;
            messagePopup(data?.msg || "잠시 후 다시 시도해주세요.")
        }).finally(() => {
        });
    }

    // 게시물 삭제
    const deleteFunc = () => {
        let sender = {
            idx: detailInfo?.idx
        }

        dispatch(
            open({
                component: `삭제 후에는 복구할 수 없습니다.
게시글을 삭제 하시겠습니까?`,
                title: "게시글 삭제",
                button: "삭제",
                buttonCencle: "취소",
                titleviewer: true,
                // wideOne: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                    APIS.postData('/v1/communityGroup/deleteBoard', sender).then(({ data }) => {

                    }).catch(({ response }) => {

                    }).finally(() => {
                        navigate(-1);
                    });
                },
                onCancelPress: () => {
                    dispatch(close());
                },
            })
        );
    }

    // 댓글 수정 활성
    const editComment = (cmtIdx) => {
        setMenuCmtIdx("") // 메뉴 사라지게

        let findCmt = orgComments.find(v => v?.idx === cmtIdx)
        if (findCmt) {
            setEditCmtText(findCmt?.desc) // 수정 클릭시 기존 텍스트 삭제
            setEditCmtIdx(cmtIdx);
        }
    }
    // 댓글 수정 완료
    const editCommentFunc = () => {
        let sender = {
            idx: editCmtIdx,
            desc: editCmtText
        }

        APIS.postData('/v1/communityGroup/comment', sender).then(({ data }) => {
            setEditCmtIdx("");
            loadDetail(true);
            dispatch(
                open({
                    component: "수정 되었습니다.",
                    title: '알림',
                    button: "확인",
                    titleviewer: true,
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                    },
                })
            );
        }).catch(({ response }) => {
            const { data } = response;
            dispatch(
                open({
                    component: data.msg,
                    title: '알림',
                    button: "확인",
                    titleviewer: true,
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                    },
                })
            );
        })
    }

    // 댓글 삭제
    const deleteComment = () => {
        let sender = {
            idx: menuCmtIdx
        }

        dispatch(
            open({
                component: `삭제 후에는 복구할 수 없습니다.
댓글을 삭제 하시겠습니까?`,
                title: "댓글 삭제",
                button: "삭제",
                buttonCencle: "취소",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                    APIS.postData('/v1/communityGroup/commentDelete', sender).then(({ data }) => {
                        loadDetail(true);
                        dispatch(
                            open({
                                component: "삭제 되었습니다.",
                                title: '알림',
                                button: "확인",
                                titleviewer: true,
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                },
                            })
                        );
                    }).catch(({ response }) => {
                        const { data } = response;
                        dispatch(
                            open({
                                component: data.msg,
                                title: '알림',
                                button: "확인",
                                titleviewer: true,
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                },
                            })
                        );
                    }).finally(() => {
                        setMenuCmtIdx("");
                    })
                },
                onCancelPress: () => {
                    dispatch(close());
                },
            })
        );
    }


    const loadGroup = () => {
        APIS.postData('/v1/communityGroup/get', {
            idx: gathering
        }).then(({ data }) => {
            setGroupInfo(data)
        }).catch(({ response }) => {
            const { data } = response;
        })
    }

    /**
     * 공지 설정
     * @param {*} idx 게시물 아이디
     * @param {*} isNotice 공지여부
     */
    const updateNotice = (idx, isNotice) => {
        let sender = {
            idx,
            g_idx: gathering,
            require: isNotice
        }

        dispatch(
            open({
                component: `공지사항을 ${isNotice ? "등록" : "해제"} 하시겠습니까?`,
                title: `공지사항 ${isNotice ? "등록" : "해제"}`,
                button: isNotice ? "등록" : "해제",
                buttonCencle: "취소",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                    APIS.postData('/v1/communityGroup/setNotice', sender)
                        .then(({ data }) => {
                            messagePopup(`${isNotice ? "등록" : "해제"} 되었습니다.`)
                            loadDetail();
                        }).catch(({ response }) => {
                            const { data } = response;
                            messagePopup(data.msg || "잠시 후 다시 시도하세요.")
                        })
                },
                onCancelPress: () => {
                    dispatch(close());
                },
            })
        );

    }

    const loadNotice = () => {
        APIS.postData('/v1/community/notice', { type: 2 }).then(({ data }) => {
            setNoticeList(data);
        }).catch(({ response }) => {
            setNoticeList(null);
        })
    }

    useEffect(() => {
        getMemberinfo(setmemberinfos);
        loadNotice();
        loadGroup();
        loadDetail();
    }, [])

    return (
        <Community>
            {reportFlag && <ReportPop boardInfo={reportData} onClose={() => { setreportFlag(false) }} />}
            <div className="community_detail_content">
                <div className="go_back">
                    <img
                        src={`./images/icons/left_arrow.svg`}
                        onClick={() => {
                            navigate("/GatheringBoard?group=" + detailInfo?.g_idx);
                        }}
                    />
                </div>
                <div className="detail_header_wrap" style={{ gap: 10 }}>
                    <div className="asking_header">
                        {/* <div className="type">매물 관련</div> */}
                        <p>{detailInfo?.title}</p>
                    </div>
                    {memberinfos?.idx == detailInfo?.user?.idx ? <div className="options" onClick={() => {
                        // console.log("/GatheringBoardWrite?group=" + detailInfo?.g_idx)
                        // return;
                        navigate("/GatheringBoardWrite?group=" + detailInfo?.g_idx, { state: { idx: detailInfo?.idx } })
                    }}>
                        <img src={`./images/icons/draft-line.svg`} />
                    </div> : <div className="options" onClick={() => {
                        setreportData({
                            board: groupInfo?.title,
                            idx: detailInfo?.idx,
                            userId:memberinfos?.idx,
                            targetId: detailInfo?.user?.idx,
                        })
                        setreportFlag(true)
                    }}>
                        <button>신고</button>
                    </div>}
                    {memberinfos?.idx == detailInfo?.user?.idx && <div className="options" onClick={deleteFunc}>
                        <img src={`./images/icons/trash.svg`} />
                    </div>}
                </div>
                <div className="writer_wrap">
                    <div className="writer_img small_delete">
                        {/* <img src={`${consts.s3url}/${memberinfos?.profile}`} /> */}
                        <div style={{
                            width: "100%",
                            height: "100%",
                            backgroundImage: `${detailInfo?.user?.profile ? "url('" + consts.s3url + "/" + detailInfo?.user?.profile + "')" : "url('./images/icons/user-3-fill-large.svg')"}`,
                            backgroundSize: `cover`
                        }} />
                    </div>
                    <div className="writer_info">
                        {/* <p>피그마 공인중개사 사무소 - 김도윤 대표/공인중개사</p>
                        <p>2024.03.15 15:46 · 조회 182</p> */}
                        <p>{detailInfo?.user?.compony?.title} - {detailInfo?.user?.name} {detailInfo?.user?.rank}/{levelText[detailInfo?.user?.level * 1]}</p>
                        <p>{moment(detailInfo?.create_dt).format("YYYY.MM.DD HH:mm")} · 조회 {detailInfo?.view}</p>
                    </div>
                </div>
                <div className="lineWidth"></div>
                <div className="detail_box_content" style={{ whiteSpace: "pre-line", width: "100%" }}>
                    {noticeList?.length > 0 ? noticeList[0]?.desc : "공지사항이 없습니다."}
                </div>
                <div>
                    <p style={{ whiteSpace: "pre-line", minHeight: 150 }}>
                        {detailInfo?.desc}
                    </p>
                </div>
                <div className="detail_img_wrapper">
                    <div className="img_wrap">
                        {detailInfo?.files?.map((item, index) => {
                            return <img key={index} src={consts.s3url + "/" + item?.file_path} />;
                        })}
                    </div>
                </div>
                <div className="comments_wrap">
                    <div className="comments_user_wrap">
                        <div className="comments_user_img">
                            {/* <img /> */}
                            <div style={{
                                width: "100%",
                                height: "100%",
                                backgroundImage: `${memberinfos?.profile ? "url('" + consts.s3url + "/" + memberinfos?.profile + "')" : "url('./images/icons/user-3-fill-large.svg')"}`,
                                backgroundSize: `cover`
                            }} />
                        </div>
                        <div className="comments_user_id">
                            <p>{memberinfos?.compony?.title}</p>
                            <p>{memberinfos?.name} {memberinfos?.rank}</p>
                        </div>
                    </div>
                    <div className="comments_write_wrap">
                        <textarea value={comment} onChange={e => { setComment(e.target.value) }} />
                        <div onClick={() => {
                            commentFunc()
                        }}>등록</div>
                    </div>
                </div>
                <div className="lineWidth"></div>

                {/* 댓글 */}
                {commentList?.map((v, i) => {
                    return <>
                        <div
                            key={"cmt-i-" + i}
                            className="comments_wrap"
                            style={{ alignItems: "flex-start" }}
                        >
                            <div className="comments_user_wrap">
                                <div className="comments_user_img">
                                    <div style={{
                                        width: "100%",
                                        height: "100%",
                                        backgroundImage: `${v?.user?.profile ? "url('" + consts.s3url + "/" + v?.user?.profile + "')" : "url('./images/icons/user-3-fill-large.svg')"}`,
                                        backgroundSize: `cover`
                                    }} />
                                </div>
                                <div className="comments_user_id">
                                    <p>{v?.user?.compony?.title}</p>
                                    <p>{v?.user?.name} {v?.user?.rank}</p>
                                </div>
                            </div>
                            <div className="comments_write_things_wrap">
                                <div className="comments_write_things">
                                    {/* 댓글내용 */}
                                    {
                                        editCmtIdx == v?.idx ?
                                            <div className="cmt_text_box">
                                                <textarea value={editCmtText} onChange={e => { setEditCmtText(e.target.value) }} />
                                                <div className="flex_colmn">
                                                    <button onClick={editCommentFunc}>완료</button>
                                                    <button onClick={() => { setEditCmtIdx("") }}>취소</button>
                                                </div>
                                            </div> :
                                            <p style={{ whiteSpace: "pre-line" }}>
                                                {v?.delete_status !== 1 ? v?.desc : "(삭제 된 댓글입니다.)"}
                                            </p>
                                    }
                                    {/* 댓글 날짜 */}
                                    <p>
                                        {moment(v?.create_dt).format("YYYY.MM.DD HH:mm")}
                                        <button
                                            onClick={() => {
                                                if (recommnetIdx === v?.idx) {
                                                    // 취소
                                                    setRecommnetIdx("")
                                                } else {
                                                    setRecommnetDesc("")
                                                    setRecommnetIdx(v?.idx)
                                                }
                                            }}
                                        >
                                            {recommnetIdx === v?.idx
                                                ? "답글취소"
                                                : "답글쓰기"}
                                        </button>
                                    </p>

                                    {recommnetIdx === v?.idx && <div className="comments_write_wrap">
                                        <textarea
                                            value={recommnetDesc}
                                            onChange={e => { setRecommnetDesc(e.target.value) }}
                                        />
                                        <div onClick={() => {
                                            //대댓글 등록
                                            commentFunc(v?.idx)
                                        }}>등록</div>
                                    </div>}
                                </div>
                                <div className="comment_manage_wrap">
                                    {v?.delete_status !== 1 && <>
                                        <img
                                            src={`./images/icons/threeDot.svg`}
                                            onClick={() => {
                                                if (v?.idx == menuCmtIdx) {
                                                    setMenuCmtIdx("")
                                                } else {
                                                    setMenuCmtIdx(v?.idx)
                                                }

                                            }}
                                        />
                                        <div className={`comment_manage ${v?.idx == menuCmtIdx ? "active" : ""}`}>
                                            {v?.user?.idx == memberinfos?.idx ? <>
                                                <p onClick={() => { editComment(menuCmtIdx) }}>수정</p>
                                                <p onClick={deleteComment}>삭제</p>
                                            </> : <>
                                                <p onClick={() => {
                                                    setMenuCmtIdx("");
                                                    setreportData({
                                                        board: groupInfo?.title,
                                                        idx: detailInfo?.idx,
                                                        userId:memberinfos?.idx,
                                                        targetId: v?.user?.idx,
                                                        commentInfo:v
                                                    })
                                                    setreportFlag(true);
                                                }}>신고</p>
                                            </>}
                                        </div>
                                    </>}
                                </div>
                            </div>
                        </div>

                        {/* 대댓글 */}
                        {v?.childs?.map((reCmt, i) => {
                            return <div
                                key={`re-cmt-i-${i}`}
                                className="comments_wrap"
                                style={{
                                    alignItems: "flex-start",
                                    marginLeft: "40px",
                                    width: "calc(100% - 40px)"
                                }}
                            >
                                <div className="comments_user_wrap">
                                    <img src={`./images/icons/comment_arrow.svg`} />
                                    <div className="comments_user_img">
                                        <div style={{
                                            width: "100%",
                                            height: "100%",
                                            backgroundImage: `${reCmt?.user?.profile ? "url('" + consts.s3url + "/" + reCmt?.user?.profile + "')" : "url('./images/icons/user-3-fill-large.svg')"}`,
                                            backgroundSize: `cover`
                                        }} />
                                    </div>
                                    <div className="comments_user_id">
                                        <p>{reCmt?.user?.compony?.title}</p>
                                        <p>{reCmt?.user?.name} {reCmt?.user?.rank}</p>
                                    </div>
                                </div>
                                <div className="comments_write_things_wrap">
                                    <div className="comments_write_things comment_comment">
                                        {/* 댓글내용 */}
                                        {
                                            editCmtIdx == reCmt?.idx ?
                                                <div className="cmt_text_box">
                                                    <textarea value={editCmtText} onChange={e => { setEditCmtText(e.target.value) }} />
                                                    <div className="flex_colmn">
                                                        <button onClick={editCommentFunc}>완료</button>
                                                        <button onClick={() => { setEditCmtIdx("") }}>취소</button>
                                                    </div>
                                                </div> :
                                                <p style={{ whiteSpace: "pre-line" }}>
                                                    {reCmt?.tag_name ? <span>@{reCmt?.tag_name} </span> : <></>}
                                                    {reCmt?.delete_status !== 1 ? reCmt?.desc : "(삭제 된 댓글입니다.)"}
                                                </p>
                                        }
                                        {/* 댓글날짜 */}
                                        <p>
                                            {moment(reCmt?.create_dt).format("YYYY.MM.DD HH:mm")}
                                            <button
                                                onClick={() => {
                                                    if (recommnetIdx === reCmt?.idx) {
                                                        // 취소
                                                        setRecommnetIdx("")
                                                    } else {
                                                        setRecommnetDesc("")
                                                        setRecommnetIdx(reCmt?.idx)
                                                    }
                                                }}
                                            >
                                                {recommnetIdx === reCmt?.idx
                                                    ? "답글취소"
                                                    : "답글쓰기"}
                                            </button>
                                        </p>

                                        {recommnetIdx === reCmt?.idx && <div className="comments_write_wrap">
                                            <textarea
                                                value={recommnetDesc}
                                                onChange={e => { setRecommnetDesc(e.target.value) }}
                                            />
                                            <div onClick={() => {
                                                //대댓글 등록
                                                // commentFunc(v?.idx, `${reCmt?.user?.name} ${reCmt?.user?.rank}`)
                                                commentFunc(v?.idx, `${reCmt?.user?.name}`)
                                            }}>등록</div>
                                        </div>}
                                    </div>
                                    <div className="comment_manage_wrap">
                                        {reCmt?.delete_status !== 1 && <>
                                            <img
                                                src={`./images/icons/threeDot.svg`}
                                                onClick={() => {
                                                    if (reCmt?.idx == menuCmtIdx) {
                                                        setMenuCmtIdx("")
                                                    } else {
                                                        setMenuCmtIdx(reCmt?.idx)
                                                    }

                                                }}
                                            />
                                            <div className={`comment_manage ${reCmt?.idx == menuCmtIdx ? "active" : ""}`}>
                                                {reCmt?.user?.idx == memberinfos?.idx ? <>
                                                    <p onClick={() => { editComment(menuCmtIdx) }}>수정</p>
                                                    <p onClick={deleteComment}>삭제</p>
                                                </> : <>
                                                    <p onClick={() => {
                                                        setMenuCmtIdx("")
                                                        setreportData({
                                                            board: groupInfo?.title,
                                                            idx: detailInfo?.idx,
                                                            userId:memberinfos?.idx,
                                                            targetId: reCmt?.user?.idx,
                                                            commentInfo:reCmt
                                                        })
                                                        setreportFlag(true)
                                                    }}>신고</p>
                                                </>}
                                            </div>
                                        </>}

                                    </div>
                                </div>
                            </div>
                        })}
                    </>
                })}

                {commentList?.length <= 0 && <p>댓글이 없습니다.</p>}
                <div className="lineWidth"></div>
                <div className="btn_wrap">
                    {(groupInfo?.u_idx == memberinfos?.idx && groupInfo?.u_idx == detailInfo?.u_idx) && <button
                        className={detailInfo?.required === 1 ? "cancel" : "register"}
                        onClick={() => {
                            if (detailInfo?.required === 1)
                                updateNotice(detailInfo?.idx, false);
                            else
                                updateNotice(detailInfo?.idx, true);
                        }}
                    >
                        공지사항 {detailInfo?.required === 1 ? "해제" : "등록"}
                    </button>}
                    <button
                        className="cancel"
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        뒤로
                    </button>
                </div>
            </div>
        </Community>
    );
};

export default GatheringContent;
